import IntranetLayout from "@/components/IntranetLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Wrench, Bug, Sparkles, ClipboardList } from "lucide-react";
import { EmployeeMaintenancePMSContent } from "./EmployeeMaintenancePMS";
import { PMSAssistantContent } from "./PMSAssistant";
import { DefectManagerContent } from "./DefectManager";
import AIManagerPanel from "@/components/ai/AIManagerPanel";

const MaintenancePMSHub = () => {
  return (
    <IntranetLayout>
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-[#00283C] font-display">Maintenance & PMS</h1>
        <p className="text-sm text-muted-foreground">
          Workbench, Vel-iO PMS Manager, PMS Assistant and Defect Manager — all human-in-the-loop.
        </p>
      </div>

      <Tabs defaultValue="workbench" className="w-full">
        <TabsList className="bg-[#F4F7FA] mb-4 flex-wrap h-auto">
          <TabsTrigger value="workbench"><Wrench className="w-4 h-4 mr-1" /> PMS Workbench</TabsTrigger>
          <TabsTrigger value="ai"><Sparkles className="w-4 h-4 mr-1" /> Vel-iO PMS Manager</TabsTrigger>
          <TabsTrigger value="assistant"><ClipboardList className="w-4 h-4 mr-1" /> PMS Assistant</TabsTrigger>
          <TabsTrigger value="defects"><Bug className="w-4 h-4 mr-1" /> Defect Manager</TabsTrigger>
        </TabsList>

        <TabsContent value="workbench" className="mt-0">
          <EmployeeMaintenancePMSContent />
        </TabsContent>

        <TabsContent value="ai" className="mt-0">
          <AIManagerPanel
            hub="pms"
            title="Vel-iO PMS Manager"
            subtitle="I monitor overdue jobs, class-survey items, condition trends and draft work orders for your approval."
            accent="text-[#8CB43C]"
            context="Hub: Planned Maintenance System. Fleet: Velocity Vanguard, Velocity Cobalto, Velocity Paladio. Focus on overdue jobs, defects, class survey deadlines, condition monitoring."
          />
        </TabsContent>

        <TabsContent value="assistant" className="mt-0">
          <PMSAssistantContent />
        </TabsContent>

        <TabsContent value="defects" className="mt-0">
          <DefectManagerContent />
        </TabsContent>
      </Tabs>
    </IntranetLayout>
  );
};

export default MaintenancePMSHub;
